import {ReactComponent as DuoBeat} from '../../assets/icons/DuoBeat.svg'
import {ReactComponent as DuoChatBubbles} from '../../assets/icons/DuoChatBubbles.svg'
import {ReactComponent as CircleOxygenIcon} from '../../assets/icons/DuoCircleOxygenIcon.svg'
import {ReactComponent as DuoHeartBeat} from '../../assets/icons/DuoHeartBeat.svg'
import {ReactComponent as DuoTemperature} from '../../assets/icons/DuoTemperature.svg'
import {ReactComponent as WindIcon} from '../../assets/icons/DuoWindIcon.svg'
// import {ReactComponent as IoChatBubbles} from '../../assets/icons/IoChatBubbles.svg'
// import {ReactComponent as RiWindyFill} from '../../assets/icons/RiWindyFill.svg'
// import {ReactComponent as SiOxygen} from '../../assets/icons/SiOxygen.svg'
export const summaryDataList = [
    {
        key: 'heartRate',
        label: 'Heart Rate',
        icon: (
            <DuoHeartBeat
                style={{
                    height: '24px',
                    width: '24px',
                    color: '#ED2B2A',
                }}
            />
        ),
        chartColor: '#FF8F8F',
        unit: 'BPM',
        isChart: true,
        className: '',
    },
    {
        key: 'oxygen',
        label: 'O2 Saturation',
        icon: (
            // <SiOxygen
            //     style={{
            //         height: '24px',
            //         width: '24px',
            //         color: '#0081B4',
            //     }}
            // />
             <CircleOxygenIcon
                style={{
                    height: '24px',
                    width: '24px',
                    color: '#0081B4',
                }}
            />
        ),
        chartColor: '#86B6F6',
        isChart: true,
        unit: '%',
        className: '',
    },
    {
        key: 'respiration',
        label: 'Respiration',
        icon: (
            // <RiWindyFill
            //     style={{
            //         height: '24px',
            //         width: '24px',
            //         color: '#03C988',
            //     }}
            // />
             <WindIcon
                style={{
                    height: '24px',
                    width: '24px',
                    color: '#03C988',
                }}
            />
        ),
        chartColor: '#C1F2B0',
        unit: 'BPM',
        isChart: true,
        className: '',
    },
    {
        key: 'temperature',
        label: 'Temperature',
        icon: (
            // <FaTemperatureHigh
            //     style={{
            //         height: '24px',
            //         width: '24px',
            //         color: '#FC7300',
            //     }}
            // />
            <DuoTemperature
                style={{
                    height: '24px',
                    width: '24px',
                    color: '#FC7300',
                }}
            />
        ),
        chartColor: '#FFC47E',
        unit: '°C',
        isChart: true,
        className: '',
    },
    {
        key: 'systolic',
        label: 'Systolic',
        icon: (
            // <TbActivityHeartBeat
            //     style={{
            //         height: '24px',
            //         width: '24px',
            //         color: '#973131',
            //     }}
            // />
             <DuoBeat
                style={{
                    height: '24px',
                    width: '24px',
                    color: '#973131',
                }}
            />
        ),
        chartColor: '#C69774',
        unit: 'mm/Hg',
        isChart: true,
        className: '',
    },
    // {
    //     key: 'diastolic',
    //     label: 'Diastolic',
    //     icon: (
    //         <TbActivityHeartBeat
    //             style={{
    //                 height: '24px',
    //                 width: '24px',
    //                 color: '#402E7A',
    //             }}
    //         />
    //     ),
    //     chartColor: '#402E7A',
    //     unit: 'mm/Hg',
    //     isChart: true,
    //     className: '',
    // },
    // {
    //     key: 'bloodGlucoseLevel',
    //     label: 'Blood Glucose Level',
    //     icon: (
    //         <GiMuscleFat
    //             style={{
    //                 height: '24px',
    //                 width: '24px',
    //                 color: '#408E91',
    //             }}
    //         />
    //     ),
    //     chartColor: '#408E91',
    //     unit: 'mmol/L',
    //     className: '',
    //     isChart: true,
    // },
    // {
    //     key: 'painScore',
    //     label: 'Pain Score',
    //     icon: (
    //         <FaSadCry
    //             style={{
    //                 height: '24px',
    //                 width: '24px',
    //                 color: '#C80036',
    //             }}
    //         />
    //     ),
    //     chartColor: '#C80036',
    //     unit: '',
    //     isChart: true,
    //     className: '',
    // },
    // {
    //     key: 'steps',
    //     label: 'Steps',
    //     icon: (
    //         <IoFootSteps
    //             style={{
    //                 height: '24px',
    //                 width: '24px',
    //                 color: '#6F4E37',
    //             }}
    //         />
    //     ),
    //     chartColor: '#6F4E37',
    //     unit: 'steps',
    //     isChart: true,
    //     className: '',
    // },
    // {
    //     key: 'calories',
    //     label: 'Calories',
    //     icon: (
    //         <IoMdNutrition
    //             style={{
    //                 height: '24px',
    //                 width: '24px',
    //                 color: '#F14E95',
    //             }}
    //         />
    //     ),
    //     chartColor: '#F14E95',
    //     unit: 'calo',
    //     isChart: true,
    //     className: '',
    // },
    // {
    //     key: 'sleep',
    //     label: 'Sleep',
    //     icon: (
    //         <GiNightSleep
    //             style={{
    //                 height: '24px',
    //                 width: '24px',
    //                 color: '#2C3848',
    //             }}
    //         />
    //     ),
    //     chartColor: '#2C3848',
    //     unit: 'hr',
    //     isChart: true,
    //     className: '',
    // },
    // {
    //     key: 'news',
    //     label: 'NEWS',
    //     icon: (
    //         <FaChartArea
    //             style={{
    //                 height: '24px',
    //                 width: '24px',
    //                 color: '#77037B',
    //             }}
    //         />
    //     ),
    //     chartColor: '#77037B',
    //     unit: '',
    //     isChart: true,
    //     className: '',
    // },
    // {
    //     key: 'tas',
    //     label: 'TAS',
    //     icon: (
    //         <AiOutlineLineChart
    //             style={{
    //                 height: '24px',
    //                 width: '24px',
    //                 color: '#57C5B6',
    //             }}
    //         />
    //     ),
    //     unit: '',
    //     chartColor: '#57C5B6',
    //     isChart: true,
    //     className: '',
    // },
    // {
    //     key: 'anySupplementaryOxygen',
    //     label: 'Any Supplementary Oxygen',
    //     icon: (
    //         <TfiSupport
    //             style={{
    //                 height: '24px',
    //                 width: '24px',
    //                 color: '#C40C0C',
    //             }}
    //         />
    //     ),
    //     chartColor: '#C40C0C',
    //     unit: '',
    //     isChart: false,
    //     className: '',
    // },
    // {
    //     key: 'bloodPressureLimb',
    //     label: 'Blood Pressure Limb',
    //     icon: (
    //         <BiBody
    //             style={{
    //                 height: '24px',
    //                 width: '24px',
    //                 color: '#FFC470',
    //             }}
    //         />
    //     ),
    //     chartColor: '#FFC470',
    //     unit: '',
    //     isChart: false,
    //     className: '',
    // },
    // {
    //     key: 'bloodPressurePosition',
    //     label: 'Blood Pressure Position',
    //     icon: (
    //         <MdBloodtype
    //             style={{
    //                 height: '24px',
    //                 width: '24px',
    //                 color: '#A0153E',
    //             }}
    //         />
    //     ),
    //     chartColor: '#A0153E',
    //     unit: '',
    //     isChart: false,
    //     className: '',
    // },
    {
        key: 'levelOfConsciousness',
        label: 'Level Of Consciousness',
        icon: (
            // <IoChatBubbles
            //     style={{
            //         height: '24px',
            //         width: '24px',
            //         color: '#4C3BCF',
            //     }}
            // />
             <DuoChatBubbles
                style={{
                    height: '24px',
                    width: '24px',
                    color: '#4C3BCF',
                }}
            />
        ),
        chartColor: '#4C3BCF',
        unit: '',
        isChart: false,
        className: '',
    },
    // {
    //     key: 'confusion',
    //     label: 'Confusion',
    //     icon: (
    //         <BsEmojiDizzyFill
    //             style={{
    //                 height: '24px',
    //                 width: '24px',
    //                 color: '#D10363',
    //             }}
    //         />
    //     ),
    //     chartColor: '#D10363',
    //     unit: '',
    //     isChart: false,
    //     className: '',
    // },
]

export const sicknessLevelOptions = [
    {value: 'normal', label: 'Normal - 0'},
    {value: 'mild', label: 'Mild - 1'},
    {value: 'moderate', label: 'Moderate - 2'},
    {value: 'severe', label: 'Severe - 3'},
]
